<script type="text/javascript">

import ListingsSellForm from "../../../../packages/listings/src/Sell/ListingsSellForm";

  export default {
    
    props: ['type', 'pc', 'slug', 'website'],
    components: {
      ListingsSellForm,
    },
    data() {
      return {
        default_content: {
          type: 'listing-form',
          title: 'Listing Form',
          active: 1,

          left_bg: 'dark',
          left_text_color: 'white',
          left_text_hl_color: 'revinre',
          left_sub_color: 'darken-gray-900',
          left_sub_text_color: 'white',
          left_sub_text_hl_color: 'revinre',
          left_incomplete_icon: 'fa:square-o',
          left_complete_icon: 'fa:check-square-o',

          right_bg: 'white',
          right_sub_bg: 'light',
          right_title_color: 'black',
          right_text_color: 'gray-700',
          right_progress_color: 'revinre',
          right_btn_color: 'success',
        },

        loading_my_listings: true,
        my_listings: [],


        default_listing: {
          // id: '',
          // status: '',
          user_id: '',
          mls_id: '',
          // on_map: '',
          // view_count: '',
          mls_title: '',
          // ListingId: '',
          StandardStatus: 'Awaiting Order',
          PropertyType: '',
          PropertySubType: '',
          StreetNumber: '',
          StreetDirPrefix: '',
          StreetName: '',
          StreetDirSuffix: '',
          StreetSuffix: '',
          UnitNumber: '',
          Address: '',
          City: '',
          StateOrProvince: '',
          CountyOrParish: '',
          Country: '',
          PostalCode: '',
          Longitude: '',
          Latitude: '',
          ListingContractDate: '',
          // ExpirationDate: '',
          // PendingTimestamp: '',
          // CancellationDate: '',
          // CloseDate: '',
          ListPrice: '',
          // ClosePrice: '',
          Ownership: '',
          YearBuilt: '',
          SeniorCommunityYN: '',
          AssociationYN: '',
          WaterSource: '',
          Electric: '',
          Sewer: '',
          LivingArea: '',
          LotSizeSquareFeet: '',
          LotSizeAcres: '',
          BedroomsTotal: '',
          BathroomsFull: '',
          BathroomsHalf: '',
          BathroomsOneQuarter: '',
          BathroomsPartial: '',
          BathroomsThreeQuarter: '',
          BathroomsTotalInteger: '',
          Stories: '',
          GarageSpaces: '',
          ParkingTotal: '',
          PoolFeatures: '',
          View: '',
          Heating: '',
          Cooling: '',
          Basement: '',
          PublicRemarks: '',
          Directions: '',
          CrossStreet: '',
          SubdivisionName: '',
          ListOfficeName: '',
          ListOfficeEmail: '',
          ListOfficePhone: '',
          ListOfficeMlsId: '',
          TaxYear: '',
          TaxAnnualAmount: '',
          PhotosCount: '',
          thumbnail: '',
          images: [],
          OwnerName: '',
          OwnerEmail: '',
          OwnerPhone: '',
          Owners: [],
          buying: '',
          is_realtor: '',
          has_realtor: '',
          referred_by: '',
          referred_name: '',

          packages_total: '',
          savings_total: '',
          estimated_total: '',
          MailingAddress: '',
          MailingCity: '',
          MailingStateOrProvince: '',
          MailingPostalCode: '',
          BillingAddress: '',
          BillingCity: '',
          BillingStateOrProvince: '',
          BillingPostalCode: '',
          active_package: {},
          services: [],
          cart: [],
          additional_input: {},
          sign_company: {},
          valuations: [],
          // mls_updated_at: '',
        },
        listing: {

        },

        editor_tabIndex: 0,

        default_form : [
          {
            stage: 'AwaitingOrder',
            title: 'Start your listing',
            require_checkout: 1,
            content: [
              {
                perm: 1,
                nodrag: 1,
                title: 'Getting started',
                content: [],
              },
              {
                perm: 1,
                nodrag: 1,
                title: 'Property address',
                content: [],
              },
              {
                perm: 1,
                nodrag: 1,
                title: 'Determine property value',
                content: [],
              },
              {
                perm: 1,
                nodrag: 1,
                title: 'Packages and services',
                content: [],
              },
              {
                perm: 1,
                nodrag: 1,
                title: 'Additional details',
                content: [],
              },
              {
                perm: 1,
                nodrag: 1,
                title: 'Submit your listing',
                content: [],
              },
            ],
          },
          {
            stage: 'AwaitingForms',
            title: 'Enter property details',
            content: [
              {
                perm: 1,
                nodrag: 1,
                title: 'Getting started',
              },
            ],
          },
          {
            stage: 'AwaitingPhotos',
            title: 'Property photos',
            content: [
              {perm: 1, nodrag: 1, title: 'Property photos'},
            ],
          },
          {
            stage: 'AwaitingSignatures',
            title: 'Review and sign',
            content: [
              {perm: 1, nodrag: 1, title: 'Review and sign'},
            ],
          },
          {
            stage: 'ListingLive',
            title: 'Listing is live',
            content: [
              {perm: 1, nodrag: 1, title: 'Listing is live'},
            ],
          },
          {
            stage: 'ListingComplete',
            title: 'Listing is complete',
            content: [
              {perm: 1, nodrag: 1, title: 'Listing is complete'},
            ],
          },
        ],
      }
    },
    created() {
      if(this.pc && this.pc.init == 'Yes') { for(var i in this.default_content) { this.pc[i] = this.default_content[i]; } this.pc.init = ''; }

      if(this.type != 'editor') {

        if(this.slug && this.slug.slug_id) {
          console.log(this.slug.slug_id);
        } else {
          this.listing = JSON.parse(JSON.stringify(this.default_listing));
          if(this.user.id) {
            this.listing.user_id = this.user.id;
            this.listing.OwnerName = this.user.name;
            this.listing.OwnerPhone = this.user.phone;
            this.listing.OwnerEmail = this.user.email;
            this.listing.referred_by = this.user.referred_by;
            this.listing.referred_name = this.user.referred_name;
            this.listing.MailingAddress = this.user.MailingAddress;
            this.listing.MailingCity = this.user.MailingCity;
            this.listing.MailingStateOrProvince = this.user.MailingStateOrProvince;
            this.listing.MailingPostalCode = this.user.MailingPostalCode;
            this.listing.BillingAddress = this.user.BillingAddress;
            this.listing.BillingCity = this.user.BillingCity;
            this.listing.BillingStateOrProvince = this.user.BillingStateOrProvince;
            this.listing.BillingPostalCode = this.user.BillingPostalCode;
          }

        }

        // this.fetch_my_listings();
      }
    },
    methods: {
      fetch_my_listings() {
        this.loading_my_listings = true;
        this.$http.get((this.isAdmin ? '/api' : '')+'/listings/fetch', {params: {paginate: 1000, page: 1, total: 0, wheres: {status: 1}}}).then(res => {
          // console.log(res);
          this.my_listings = res.data.data;
          this.loading_my_listings = false;
        }).catch(res => {
          this.loading_my_listings = false;
          // this.$noty.warning("There was an error loading the required data. Please try again and contact support if the problem persists.");
        });
      },
    }
  }
</script>

<template>
  <section>

    <div v-if="type == 'editor'">
      <div class="p-3">
        <div class="row mb-4">
          <div class="col-sm-4">
            <w-field SimpleDataType="String List, Single" v-model="pc.active" Title="Active :" :Options="[{name:'Yes',value:1},{name:'No',value:0}]" v-tippy content="Display this section on the live website?"></w-field>
          </div>
        </div>

        <div class="alert alert-danger">This widget is still in development. For the time being this widget must be edited in the MLSs section.</div>
        <div class="alert alert-danger">In order for this widget to function correctly "/:id" must be used at the end of this page's slug. For example "/my-listings/:id".</div>
        <div class="alert alert-danger">Any URL's pointing to this page must use "/new" at the end of the url for new listings and "/:id" for existing listings. For example "/my-listings/new" and "/my-listings/D534Daf6".</div>

        <!-- <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Form navigation :</h6>
        left_bg
        left_text_color
        left_text_hl_color
        left_sub_color
        left_sub_text_color
        left_sub_text_hl_color
        left_incomplete_icon
        left_complete_icon

        <h6 class="section-header mt-3"><Icon icon="ri:book-2-line"></Icon> Form page :</h6>
        right_bg
        right_sub_bg
        right_title_color
        right_text_color
        right_progress_color
        right_btn_color -->

        <div class="mt-4">
          <a @click="$refs.modal_page_editor.show()" class="btn btn-success text-white waves-effect waves-light ml-1"><Icon icon="ri:window-2-line" /> Open editor</a>
          <b-modal ref="modal_page_editor" centered size="xxl" title="Form editor" :no-close-on-backdrop="false" :no-close-on-esc="false" :hide-footer="true">
            <div class="" style="margin: 0px 27px 0px">
              <b-tabs class="nav-bordered header-nav hide-content" lazy v-model="editor_tabIndex">
                <b-tab><template v-slot:title>Editor</template></b-tab>
                <b-tab><template v-slot:title>Field output</template></b-tab>
              </b-tabs>
            </div>
            <div v-show="editor_tabIndex == 0">
              <div class="row mx-0 set-sm-325 _h-n-100vh-n-55">
                <div class="col-sm-4 p-0 bg-dark text-white small">
                  <ul class="list-unstyled m-0">
                    <li v-for="(item, item_i) in default_form" :key="item_i" class="border-bottom border-black">
                      <div class="px-3 py-3">{{item.title}}</div>
                      <ul class="list-unstyled bg-darken-gray-900">
                        <li v-for="(sub_item, sub_item_i) in item.content" :key="sub_item_i" class="pl-3 border-top border-black">
                          <div class="p-2">
                            <div class="input-group input-group-sm">
                              <input type="text" placeholder="Page title" v-tippy content="Page title" class="form-control form-control-sm bg-darken-gray-900 border-black text-white px-1" v-model="sub_item.title" style="background:transparent;">
                              <div class="input-group-append">
                                <button type="button" v-tippy content="View/edit page content" class="btn btn-sm btn-outline-black text-white"><Icon icon="ri:edit-2-line" /></button>
                                <button v-if="!sub_item.perm" type="button" v-tippy content="Delete page" class="btn btn-sm btn-outline-black text-white"><Icon icon="ri:delete-bin-6-line" /></button>
                                <button v-if="!sub_item.nodrag" type="button" v-tippy content="Drag to arrange" class="btn btn-sm btn-outline-black text-white handle" data-tippy-directive=""><Icon icon="ri:drag-move-2-fill" /></button>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>

                      <!-- <div class="bg-darken-gray-900 text-right small p-2 border-top border-black">
                        <button class="btn btn-sm btn-success" type="button" v-tippy content="Add page" @click="item.content.push({perm: 0, nodrag: 0, title: ''})"><Icon icon="ri:add-line" /> Add page</button>
                      </div> -->

                    </li>
                  </ul>
                </div>
                <div class="col-sm-8 p-0 bg-white">

                  <!-- Top navbar -->
                  <div class="row m-0">
                    <div class="col-sm-6 p-0">
                      <ul class="m-0 list-unstyled list-inline text-gray-600 small">
                        <li class="list-inline-item small">
                          <div class="px-3 py-2">List price:<div class="_f-s-14 font-weight-bold text-success">$400,000</div></div>
                        </li>
                        <li class="list-inline-item small">
                          <div class="px-3 py-2">Your savings:<div class="_f-s-14 font-weight-bold text-success">$10,000</div></div>
                        </li>
                        <li class="list-inline-item small">
                          <div class="px-3 py-2">Total cost:<div class="_f-s-14 font-weight-bold text-success">$0</div></div>
                        </li>
                      </ul>
                    </div>
                    <div class="col-sm-6 p-0 text-right">
                      <ul class="m-0 list-unstyled list-inline">
                        <li class="list-inline-item" v-tippy content="Purchase Upgrades"><div class="p-3 text-gray-800 text-hover-black"><Icon icon="mdi:gift-outline" width="25" /></div></li>
                        <li class="list-inline-item" v-tippy content="Orders & Invoices"><div class="p-3 text-gray-800 text-hover-black"><Icon icon="mdi:clipboard-text-clock-outline" width="25" /></div></li>
                        <li class="list-inline-item" v-tippy content="Shopping Cart"><div class="p-3 text-gray-800 text-hover-black"><Icon icon="mdi:cart-outline" width="25" /></div></li>
                        <li class="list-inline-item" v-tippy content="Help"><div class="p-3 text-gray-800 text-hover-black"><Icon icon="mdi:tooltip-question-outline" width="25" /></div></li>
                      </ul>
                    </div>
                  </div>
                  <div class="progress mx-3 _h-5"><div class="progress-bar progress-bar-striped progress-bar-animated bg-warning" :style="'width:29%'"></div></div>

                  <div class="p-5">
                    
<pre>
Getting started

Property address
  Property address widget
Determine property value
  Property valuation widget
Packages and services
  Packages & services widget
Submit your listing
  Shopping cart widget
  Checkout widget


Photo uploader widget
Purchase upgrades widget
Review & sign widget
Preview listing widget
Order history/invoice widget
</pre>


                    <!-- <component is="sell-form-add-content"></component> -->
                  </div>

                </div>
              </div>
            </div>
            <div v-show="editor_tabIndex == 1">
              <div class="bg-light p-3">
                dd
              </div>
            </div>
          </b-modal>
        </div>

      </div>
    </div>

    <div v-else>
      <ListingsSellForm :slug="slug" :website="website"></ListingsSellForm>
    </div>
  </section>

</template>
